import requestToken from './request-token';

export default {
	requestToken
};
